import React from 'react'
import { useIntl } from 'react-intl'

import { Order as OrderModel } from 'msp-integrations'
import { CustomLinkComponent, DynamicTag } from 'msp-components'

import translations from './OrderDetailHeader.constants'
import * as S from './OrderDetailHeader.styles'

export const OrderDetailHeader = ({ order }: { order: OrderModel }) => {
  const { formatMessage } = useIntl()

  return (
    <DynamicTag componentTagName='Headline' tag='h6' className={S.Wrapper}>
      <CustomLinkComponent
        href='/account/orders'
        className={S.GoBackWrapper}
        uppercase={false}
        inline
      >
        {formatMessage(translations.goBack)}
      </CustomLinkComponent>
      {formatMessage(translations.myOrder, {
        orderNo: order.orderNo
      })}
    </DynamicTag>
  )
}

export default OrderDetailHeader
